import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMe } from './useMe'

// The mirror image of every authenticated page's `if (me.isError) navigate('/login')`:
// an already-logged-in visitor landing on /login or /signup got the form anyway, with the
// app shell above it cheerfully showing their credit balance and org name. Sends them to
// the dashboard instead. replace: true so Back doesn't bounce them straight back onto the
// form they were just redirected off.
export function useRedirectIfAuthenticated(to = '/dashboard') {
  const me = useMe()
  const navigate = useNavigate()
  useEffect(() => {
    if (me.isSuccess) navigate(to, { replace: true })
  }, [me.isSuccess, navigate, to])
  return me
}
